import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Dialog, Heading, RichTextEditor } from '@innovationnorway/cl-react';

interface WriteMessageToCustomerStepProps {
  dialogOpen: boolean;
  onClose: () => void;
  initialCustomerMessage: string;
  setCustomerMessage: React.Dispatch<React.SetStateAction<string>>;
  sanitizedCustomerMessage: string;
  onSendEmail: () => void;
}

const WriteMessageToCustomerStep = ({
  dialogOpen,
  onClose,
  initialCustomerMessage,
  setCustomerMessage,
  sanitizedCustomerMessage,
  onSendEmail,
}: WriteMessageToCustomerStepProps) => {
  const { t: tCommon } = useTranslation();
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  const [customerMessageError, setCustomerMessageError] = useState(false);

  return (
    <Dialog
      open={dialogOpen}
      onClose={onClose}
      aria-label={tOneWayIn('refer.dialog.ariaLabel')}
      className="refer-dialog"
    >
      <Heading level={2} className="refer-dialog--heading">
        {tOneWayIn('refer.dialog.writeMessageToCustomer')}
      </Heading>
      <div className="refer-dialog--layout">
        <div className="refer-dialog--body gap--ds-5 margin-bottom--ds-5">
          <span>{tOneWayIn('refer.dialog.customerEmailPrompt.description')}</span>
          <span className="font-weight--500">{`${tCommon('subject')}: Ny henvisning i Flerbedriftsportalen`}</span>
          <RichTextEditor
            key={initialCustomerMessage}
            rows={12}
            initialValue={initialCustomerMessage}
            onChange={(value) => setCustomerMessage(value)}
          />
          <span>MERK: Svar til denne e-postadressen blir ikke behandlet.</span>
        </div>
        {customerMessageError && (
          <Alert data-color="danger" className="font-weight--500 margin-left--ds-6">
            {tOneWayIn('refer.validation.messageEmpty')}
          </Alert>
        )}
        <div className="refer-dialog--action-row">
          <Button
            onClick={() => {
              if (sanitizedCustomerMessage === '' || sanitizedCustomerMessage === '<p><br></p>') {
                setCustomerMessageError(true);
                return;
              }
              setCustomerMessageError(false);
              onSendEmail();
            }}
          >
            {tCommon('sendEmail')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default WriteMessageToCustomerStep;
